export default __webpack_public_path__ + "static/media/searchGray.e259fee3.svg";